/**
 * Lojas do Gestão Click que faturam PontuaX. A loja define em qual conta bancária o boleto é
 * emitido e qual forma de pagamento é usada, então errar aqui manda o boleto para o banco errado.
 *
 * Ids crus de propósito — loja nova no ERP não deve exigir migration.
 */
export enum GestaoClickStore {
  PONTUAX = '201797',
  PONTUAX_TEC = '191535',
}

export const gestaoClickStoreChoices = [
  { id: GestaoClickStore.PONTUAX, name: 'PontuaX' },
  { id: GestaoClickStore.PONTUAX_TEC, name: 'PontuaX Tec' },
];
